/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { PageContentMessage } from "../../../messages";
import { VApplication } from "../../../../../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_LEAF_NODES } from "../../../graphql";
import { DEFAULT_APP_CONFIG } from "../../../../../config/default.config";

const MODULE_NAME =
  "services.PortfolioUnderReviewPageService.machines.GetPageContent.state.getLeafNodes";
const log = LoggerModule?.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export const getLeafNodes = async (context: any, event: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const msg = context?.input as PageContentMessage;
      const graphqlModule = getGraphQLModule();
      const client = graphqlModule.getClient("graphql-gateway");
      const res = await client?.query({
        query: GET_LEAF_NODES,
        variables: {
          input: {
            criteria: {
              store: DEFAULT_APP_CONFIG.storeId,
              state: "LISTED",
              category: msg?.collectionId,
            },
            offset: msg?.offset,
            size: msg?.size,
          },
        },
        fetchPolicy: "network-only",
      });
      if (msg.leafNodes && res?.data?.getListOfAsset) {
        const result = res?.data?.getListOfAsset;
        msg.leafNodes.data = result?.data;
        msg.leafNodes.currentPage = result?.currentPage;
        msg.leafNodes.totalCount = result?.totalCount;
        msg.leafNodes.totalPages = result?.totalPages;
        return resolve(true);
      }
      const error = "Query result does not have proper formatted values";
      log?.error(MODULE_NAME, "error in getLeafNodes", error);
      return reject(error);
    } catch (err: any) {
      log?.error(MODULE_NAME, "error in getLeafNodes", err);
      return reject(err?.message);
    }
  });
};
